import { ActivityTypeId, MimeType } from '../graph/schema-generated-types-student';

const internalResourceTypes = [
  ActivityTypeId.READ_ALOUD,
  ActivityTypeId.READ_STORY,
  ActivityTypeId.SOUND_OUT_WORDS,
  ActivityTypeId.FIND_THE_LETTER,
  ActivityTypeId.FIND_THE_OBJECTS,
  ActivityTypeId.GUESS_WHO,
  ActivityTypeId.GUESS_WHERE,
  ActivityTypeId.GUESS_THE_ORDER,
  ActivityTypeId.FEELINGS_MATCH,
];

export const MIME_TYPE_MAP = {
  [MimeType.MPEG]: 'audio/mpeg',
  [MimeType.MP4]: 'video/mp4',
  [MimeType.PNG]: 'image/png',
  [MimeType.PDF]: 'application/pdf',
};

const PRODUCT_FAMILY = 'AZMM';

const userMediaPrivilege = {
  audio: true,
  video: {
    facingMode: 'environment',
  },
};

const activityTypeFactory = (activityType: ActivityTypeId): any => {
  switch (activityType) {
    default:
      throw new Error('Activity Type not supported');
  }
};

const contactInformation = [
  {
    title: 'officeHours',
    value: ['Monday - Friday, 8:30 am - 5:30 pm (ET)'],
  },
  {
    title: 'phone',
    value: ['301.263.2700 | 1.888.983.8409'],
  },
  {
    title: 'version',
    value: [process.env.REACT_APP_APP_VERSION],
  },
];

export default {
  productFamilyCode: PRODUCT_FAMILY,
  MIME_TYPE_MAP,
  internalResourceTypes,
  activityTypeFactory,
  userMediaPrivilege,
  contactInformation,
};
